// src/portal-app/shell/kit/tones.js
//
// The kit's tone vocabulary: one map from a semantic tone name to the CSS
// custom property that carries its hue.
//
// CondensedRow, AvatarRow, ShareBar and ProfileHero all colour themselves
// from this. Keeping four private copies would guarantee drift the first
// time a tone is added, so it lives here once and is frozen.
export const TONES = Object.freeze({
    blue:   '--c-blue',
    teal:   '--c-teal',
    purple: '--c-purple',
    amber:  '--c-amber',
    green:  '--c-success',
    red:    '--c-red',
    muted:  '--c-muted',
});

// Ordered palette for auto-colouring a list (avatars) where the caller has
// not chosen tones itself.
export const FALLBACK_TONES = Object.freeze(['blue', 'teal', 'purple', 'amber', 'green']);

export function toneVar(tone) {
    return TONES[tone] || TONES.blue;
}
